import rootReducer from "./RootReducer";
import { configureStore } from "@reduxjs/toolkit";

// const middlewares: any[] = [resourceApi.middleware];
const middlewares: any[] = [];

const store: any = configureStore({
  reducer: rootReducer(),
  // reducer: {
  //   ...rootReducer(),
  //   [resourceApi.reducerPath]: resourceApi.reducer,
  // }, // Pass the asyncReducers argument to the rootReducer function
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares) as any,
  devTools: import.meta.env.VITE_APP_ENV === "development",
});

store.asyncReducers = {};

export const injectReducer = (key: string | number, reducer: any) => {
  if (store.asyncReducers[key]) {
    return false;
  }
  store.asyncReducers[key] = reducer;
  store.replaceReducer(rootReducer(store.asyncReducers));
  return store;
};

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
